import axios from "axios";
import { newApiBaseUrl } from "../../axiosInstance";
import { mapDeliveryPricesToTiers } from "../utils/deliveryPricing";

const pgwHeaders = () => ({
  "Content-Type": "application/json",
  Authorization: `bearer ${localStorage.jwtToken}`,
  "X-Tenant": "hamazon",
});

/** GET delivery price tiers for a branch (PGW → ODS), mapped for checkout. */
export const getDeliveryPrices = async (branch) => {
  const response = await axios.get(
    `${newApiBaseUrl}/deliveryprices?branch=${branch}`,
    {
      headers: pgwHeaders(),
    },
  );
  return mapDeliveryPricesToTiers(response.data);
};
